export const launchVideoAsk = (videoAskUrl: string) => {
  //const videoAskUrl =     'https://digitalassistant.esssuper.com.au/fsdck9nxn'

if (
  !videoAskUrl.includes('digitalassistant.esssuper.com.au') &&
  !videoAskUrl.includes('videoask')
) {
  console.error(
    `Invalid VideoAsk URL: ${videoAskUrl}`
  )
  return
}

const openModal = () => {
  const existingModal = document.querySelector(
    '.videoask-embed__modal_iframe--HKJSB'
  )

  if (existingModal) {
    return
  }

  if ((window as any).videoask?.loadModal) {
    ;(window as any).videoask.loadModal({
      url: videoAskUrl,
    })
  }
}

  // Script already loaded
  if ((window as any).videoask?.loadModal) {
    openModal()
    return
  }

  const existingScript =
    document.getElementById('videoask-script')

  if (!existingScript) {
    const script = document.createElement('script')

    script.id = 'videoask-script'
    script.src =
      'https://www.videoask.com/embed/embed.js'
    script.async = true

    script.onload = () => {
      openModal()
    }

    document.body.appendChild(script)
  }
}

